import { render, staticRenderFns } from "./dialog-unlock-two-record .vue?vue&type=template&id=eb798f52&scoped=true&"
import script from "./dialog-unlock-two-record .vue?vue&type=script&lang=js&"
export * from "./dialog-unlock-two-record .vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb798f52",
  null
  
)

export default component.exports